import { useMsal } from "@azure/msal-react";
import IconButton from "@mui/material/IconButton";
import { FiLogOut } from "react-icons/fi";

const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = (logoutType: string) => {
    instance.logoutRedirect();
  };

  return (
    <div>
      <IconButton onClick={() => handleLogout("redirect")} color="warning">
        <FiLogOut size={24} />
      </IconButton>
    </div>
  );
};

export default SignOutButton;
